import { useIsMounted } from "@deligoo/ui"
import { DependencyList, Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from "react"

export function useSearchBox(
  isShownInitially = false,
  initialSearchValue = ""
): {
  isSearchBoxShown: boolean
  toggleSearchBox: () => void
  searchValue: string
  setSearchValue: Dispatch<SetStateAction<string>>
} {
  const [isSearchBoxShown, setIsSearchBoxShown] = useState(isShownInitially)
  const [searchValue, _setSearchValue] = useState(initialSearchValue)

  const setSearchValue = useCallback(_setSearchValue, [_setSearchValue])

  const toggleSearchBox = useCallback(() => {
    setIsSearchBoxShown((isSearchBoxShown) => {
      if (isSearchBoxShown) setSearchValue("")
      return !isSearchBoxShown
    })
  }, [setSearchValue])

  return { isSearchBoxShown, toggleSearchBox, searchValue, setSearchValue }
}

export function useAsyncEffect(
  effect: (isMounted: () => boolean) => void | (() => void),
  deps?: DependencyList | undefined
) {
  const isMounted = useIsMounted()

  //eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => effect(isMounted), deps)
}

export function usePrevious<T>(value: T) {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}
